export enum VistaBloquesType {
	guiaDigital = 'GuiaDigital',
	cursosOnline = 'CursosOnline',
	preguntaFrecuente = 'PreguntaFrecuente'
}
